import { Component, ViewChild } from '@angular/core';
import { FileUpload } from 'primeng/fileupload';
import { HttpService } from "../../service/http.service";
import { GeneralSupplier } from 'src/app/general-supplier';
import { GeneralSupplierPaymentType } from 'src/app/general-supplier-payment-type';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GeneralSupplierInvoiceForm } from "../../form-template/general-supplier-invoice-form";
import * as moment from 'moment';
import { GeneralSupplierInvoice } from 'src/app/general-supplier-invoice';
import Decimal from 'decimal.js';
import { Moment } from 'moment';
import { Currency } from 'src/app/currency';
import { ToastMessageService } from '../../toast-message.service';
import { ApiError } from 'src/app/api-error';
import { MenuItem, SelectItem } from 'primeng/api';
import { DropdownChangeEvent } from 'primeng/dropdown';
import { UserService } from 'src/app/service/user.service';

@Component({
  selector: 'app-create-paid-invoice',
  templateUrl: './create-paid-invoice.component.html',
  styleUrl: './create-paid-invoice.component.css'
})
export class CreatePaidInvoiceComponent {

  suppliers: GeneralSupplier[] = [];
  paymentTypes: GeneralSupplierPaymentType[] = [];
  selectedFile: File | null = null;
  @ViewChild("fileUploader") fileUploader: FileUpload | null = null;
  invoiceForm: FormGroup<GeneralSupplierInvoiceForm>;
  paidByList: SelectItem[] = [
    { label: "Myself", value: 0 },
    { label: "Automatic", value: 1 },
    { label: "Fabrice", value: 2 }
  ];

  topMenuItems: MenuItem[] = [];
  canAddInvoice: boolean = false;

  isSupplierDialogVisible: boolean = false;
  supplierForm: FormGroup;

  isCreatingInvoice = false;

  constructor(
    private httpService: HttpService,
    private builder: FormBuilder,
    public toastService: ToastMessageService,
    private userService: UserService
  ) {
    this.httpService.getGeneralSuppliers().subscribe(res => {
      this.suppliers = res;
    });
    this.httpService.getGeneralSupplierPaymentTypes().subscribe(res => {
      this.paymentTypes = res;
    });
    if(userService.isNot("accountant")){
      this.canAddInvoice = true;
    }
    this.topMenuItems = [
      { label: "Invoices", routerLink: ["/management/general-supplier-invoice/invoices"] },
      { label: "Unpaid invoices", routerLink: ["/management/general-supplier-invoice/unpaid-invoices"], visible: this.canAddInvoice},
      { label: "Add invoice to be paid", routerLink: ["/management/general-supplier-invoice/create-unpaid-invoice"], visible: this.canAddInvoice}
    ];

    this.invoiceForm = builder.group<GeneralSupplierInvoiceForm>({
      supplier: new FormControl(),
      amount: new FormControl(),
      date: new FormControl(),
      file: null,
      comment: new FormControl(),
      paymentType: new FormControl(null),
      paidDate: new FormControl(null),
      paidBy: new FormControl(0),
      invoiceNumber: new FormControl(null)
    });
    this.supplierForm = builder.group({
      name: new FormControl<string | null>(null, Validators.required)
    });
  }

  submitSupplier() {
    let supplier: GeneralSupplier = {
      name: this.supplierForm.value.name,
      id: null
    };
    this.httpService.postGeneralSupplier(supplier).subscribe(() => {
      this.invoiceForm.controls.supplier.setValue(null);
      this.httpService.getGeneralSuppliers().subscribe(res => {
        this.suppliers = res;
        this.supplierForm.reset();
        this.isSupplierDialogVisible = false;
      });
    });
  }

  activateSupplierDialog() {
    this.isSupplierDialogVisible = true;
  }

  onFileSelect(files: File[]) {
    if (files.length > 0) {
      this.selectedFile = files[0];
    }
  }
  clearSelectedFile() {
    this.fileUploader?.clear();
    this.selectedFile = null;
  }

  submit() {
    if (this.invoiceForm.value.date) {
      let date = moment(this.invoiceForm.value.date);
      let paidDate: Moment | null = null;
      if (this.invoiceForm.value.paidDate) {
        paidDate = moment(this.invoiceForm.value.paidDate);
      }
      let invoiceNumber: string | null = null;
      if(this.invoiceForm.value.invoiceNumber && this.invoiceForm.value.invoiceNumber.length > 0){
        invoiceNumber = this.invoiceForm.value.invoiceNumber;
      }
      let comment = null;
      if (this.invoiceForm.value.comment && this.invoiceForm.value.comment.length > 0) {
        comment = this.invoiceForm.value.comment.trim();
      }

      let invoice: GeneralSupplierInvoice = {
        id: null,
        date: date,
        createdBy: null,
        amount: new Decimal(this.invoiceForm.value.amount!),
        currency: new Currency(1, "Euro", "EUR", "€"),
        type: this.invoiceForm.value.paymentType!,
        supplier: this.invoiceForm.value.supplier!,
        created: null,
        fileName: null,
        paidDate: paidDate,
        paidBy: null,
        invoiceNumber: invoiceNumber,
        comment: comment
      };

      if ((invoice.type.id == 4 && this.invoiceForm.controls.paidBy.value != 1) || (this.invoiceForm.controls.paidBy.value == 1 && invoice.type.id != 4)) {
        this.toastService.addError("Error", "Please select 'Paid by automatic' when the invoice is paid by automatically");
      } else {
        this.isCreatingInvoice = true;
        this.httpService.postGeneralSupplierInvoice(invoice, this.selectedFile!, this.invoiceForm.value.paidBy!).subscribe(() => {
          console.log("success");
          this.toastService.addSuccess("Success", "You added new invoice");
          this.invoiceForm.reset();
          this.invoiceForm.controls.paidBy.setValue(0);
          this.clearSelectedFile();
          this.isCreatingInvoice = false;
        }, error => {
          let apiError = new ApiError(error);
          this.toastService.addApiError(apiError);
          this.isCreatingInvoice = false;
        });
      }
    } else {
      console.error("date is missing");
    }
  }

  onPaymentTypeChange(event: DropdownChangeEvent) {
    if (event.value.id === 4) {
      this.invoiceForm.controls.paidBy.setValue(1);
    }
  }
}
